import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "upload" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 商品视频素材上传 ", -1)
const _hoisted_3 = { class: "videoBox" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "iconTextBox fiwvText" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "请上传5-10条商品"),
  /*#__PURE__*/_createElementVNode("p", null, "多角度拍摄的视频素材"),
  /*#__PURE__*/_createElementVNode("p", null, "每条视频不少于 20s"),
  /*#__PURE__*/_createElementVNode("p", null, "点击或拖拽视频至此处"),
  /*#__PURE__*/_createElementVNode("p", null, "上传")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "请上传 5-10 条商品多角度拍摄的视频素材，每条视频不少于 20s"),
  /*#__PURE__*/_createElementVNode("p"),
  /*#__PURE__*/_createElementVNode("p", null, "点击或拖拽视频至此处上传")
], -1)
const _hoisted_8 = { class: "valueBox" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "shopNameTitle" }, " 商品信息输入 ", -1)
const _hoisted_10 = { class: "shopName" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "shopName-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, " * "),
  /*#__PURE__*/_createTextVNode(" 商品名称 ")
], -1)
const _hoisted_12 = { class: "titleBox" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, " * "),
  /*#__PURE__*/_createTextVNode(" 商品卖点 ")
], -1)
const _hoisted_14 = { class: "createBtn" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("创建商品AI视频模型")
const _hoisted_16 = { class: "iconBox" }

import { UploadFile, ElMessage } from 'element-plus';
import { useStore } from 'vuex';
import { computed, reactive, ref, onMounted } from 'vue';
import bus from '@/utils/bus';
import Api from '@/api';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const inputArr = reactive({
    input1: '',
    input2: '',
    input3: '',
    input4: '',
    input5: ''
});
const shopNameArr = ref([]);
const shopName = ref(''); //产品列表传过来的
const imageBase64 = ref('');
const detailObj = ref({});
const videoArr = ref([]);//视频回显数组
const resourceIdDetail = ref('');
const resetResourceImg = () => {
    imageBase64.value = '';
};
const videoNumArr = ref([]);

// const uploadSuccess=(file)=>{
//    console.log(file)
// }

//获取商品列表
const getListFn = async () => {
    const result = await Api.Video.lookAilist('product_video');

    shopNameArr.value = result.data;

};

onMounted(() => {
    // eslint-disable-next-line no-use-before-define
    getDetailObj();
    getListFn();
});

//获取存储的detailObj 详情数据
const getDetailObj = () => {
    let detailObj = sessionStorage.getItem('detailObj');

    if (detailObj) {
        detailObj = JSON.parse(detailObj);
        console.log(detailObj.detail
        );
        if (detailObj.detail.data) {
            videoArr.value = detailObj.detail.data;
        }
        shopName.value = detailObj.detail.name;
        resourceIdDetail.value = detailObj.detail.id;

    }
};


// eslint-disable-next-line no-console
const deteleFn = (index: number) => {
    // videoArr.value.splice(index,1)
    let newArr = videoArr.value.filter((v, i) => {

        return i !== index;
    });

    videoArr.value = newArr;

};

const setFileAsBase64 = async (file: UploadFile) => {

    let url = URL.createObjectURL(file.raw);
    let audioElement = new Audio(url);
    let duration;

    audioElement.addEventListener('loadedmetadata', function () {
        duration= audioElement.duration;
        if(duration<20){
            videoArr.value = [];
            ElMessage({
                message: '请上传20s以上的商品视频素材',
                type: 'error'
            });

            return false;
        }

    });

    //   console.log(file);
    imageBase64.value = (await (async (): Promise<string> => new Promise((resolve, reject) => {
        if (!file.raw) {
            return reject();
        }
        if(!file.raw.type.includes('video')){
            ElMessage({
                message: '提交的文件不是视频，请按要求提交',
                type: 'error'
            });
            return false;
        }
        //  filePath.value=URL.createObjectURL(file.raw);
        // console.log(filePath.value)
        videoArr.value.push({ video: URL.createObjectURL(file.raw) });
        const reader = new FileReader();
        let imgResult = '';

        reader.readAsDataURL(file.raw);
        reader.onload = function () {
            imgResult = reader.result as string;
        };
        reader.onerror = function (error) {
            reject(error);
        };
        reader.onloadend = function () {
            resolve(imgResult);

        };
    }))()).split(',')[1];
    videoNumArr.value.push(imageBase64.value);
    //  console.log(imageBase64.value)
};

//提及视频
const upVideo = async (id: string, fs64: any) => {
    let result = await Api.Resource.upDataAi({ resourceId: id, video: fs64 });
};

const toTop = () => {
    sessionStorage.removeItem('detailObj');

    store.commit('comShow/upDataShow', 'Generate');
};


//用户上传ai资源
const setUploadMes = async () => {
    //判断有没有重命名
    let flag = shopNameArr.value.findIndex((v) => {
        return v.name === shopName.value;
    });

    if (sessionStorage.getItem('detailObj')) {//修改
        if (flag > -1) {//有重复
            ElMessage({
                message: '已有该商品AI视频模型，请更换命名',
                type: 'error'
            });
            getDetailObj();
            return false;
        } else {//没有重复的  直接修改
            let result = await Api.Resource.upDataAi({ resourceId: resourceIdDetail.value, productName: shopName.value });

            if (!result.error) {
                ElMessage({
                    message: '修改成功',
                    type: 'success'
                });
                getListFn();
            }
        }
    } else {
        //上传
        if (flag > -1) {//有相同名字的
            ElMessage({
                message: '您的AI商品视频模型正在创建中完成后请到AI商品视频模型库查看',
                type: 'error'
            });
            return false;
        } else {
            // 没有重复的  直接上传
            const arr = [inputArr.input1,inputArr.input2,inputArr.input3,inputArr.input4,inputArr.input5];
            

            // arr.push(inputArr);
            if (videoArr.value.length < 5) {
                ElMessage({
                    message: '您上传商品 AI 视频模型不足五条',
                    type: 'error'
                });
                return false;
            }

            if(shopName.value === ''){
                ElMessage({
                    message: '请输入商品名称',
                    type: 'error'
                });
                return false;

            }
            if (arr[0] === '') {
                ElMessage({
                    message: '至少上传一条商品卖点',
                    type: 'error'
                });
                return false;
            }
            if (arr[0] !== '' && shopName.value !== '') {

                ElMessage({
                    message: '正在创建,请稍等',
                    type: 'warning'
                });
                // arr.push(inputArr.input1, inputArr.input2, inputArr.input3, inputArr.input4, inputArr.input5);
                let result = await Api.Resource.upLoadAi('video_product_sku', shopName.value, arr);

                if (!result.error) {
                    detailObj.value = result.data;
                    ElMessage({
                        message: `${shopName.value}AI视频模型模型正在训练中,预计训练时间为两天`,
                        type: 'success'
                    });
                    getListFn();
                }
            }
            // console.log(detailObj.value)
            videoNumArr.value.forEach(v => {
                upVideo(detailObj.value?._id, v);
            });
        }
    }
};
// };


return (_ctx: any,_cache: any) => {
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ArrowLeftBold = _resolveComponent("ArrowLeftBold")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (videoArr.value.length)
      ? (_openBlock(), _createBlock(_component_el_upload, {
          key: 0,
          class: "upload-demo",
          drag: "",
          action: "",
          "show-file-list": false,
          multiple: "",
          "on-change": setFileAsBase64,
          "on-remove": resetResourceImg,
          "list-type": "picture-card",
          "auto-upload": false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoArr.value, (v, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                  _createElementVNode("video", {
                    src: v.video
                  }, null, 8, _hoisted_4),
                  _createVNode(_component_el_icon, {
                    onClick: _withModifiers(($event: any) => (deteleFn(i)), ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Close)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ], 64))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                default: _withCtx(() => [
                  _createVNode(_component_upload_filled)
                ]),
                _: 1
              }),
              _hoisted_6
            ])
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_el_upload, {
          key: 1,
          class: "upload-demoTwo",
          drag: "",
          action: "",
          "on-success": _ctx.uploadSuccess,
          "show-file-list": false,
          multiple: "",
          "on-change": setFileAsBase64,
          "on-remove": resetResourceImg,
          "list-type": "picture-card",
          "auto-upload": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
              default: _withCtx(() => [
                _createVNode(_component_upload_filled)
              ]),
              _: 1
            }),
            _hoisted_7
          ]),
          _: 1
        }, 8, ["on-success"])),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_el_input, {
            modelValue: shopName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (shopName.value = $event)),
            placeholder: "请输入商品名称或选择输入过的商品信息"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("p", null, [
            _createVNode(_component_el_input, {
              modelValue: _unref(inputArr).input1,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(inputArr).input1 = $event)),
              placeholder: "请输入商品卖点，每一个输入栏输入一个买点，按优先级依次排序"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              modelValue: _unref(inputArr).input2,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(inputArr).input2 = $event)),
              placeholder: "请输入商品卖点，每一个输入栏输入一个买点，按优先级依次排序"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              modelValue: _unref(inputArr).input3,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_unref(inputArr).input3 = $event)),
              placeholder: "请输入商品卖点，每一个输入栏输入一个买点，按优先级依次排序"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              modelValue: _unref(inputArr).input4,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_unref(inputArr).input4 = $event)),
              placeholder: "请输入商品卖点，每一个输入栏输入一个买点，按优先级依次排序"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              modelValue: _unref(inputArr).input5,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_unref(inputArr).input5 = $event)),
              placeholder: "请输入商品卖点，每一个输入栏输入一个买点，按优先级依次排序"
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_el_button, {
        onClick: setUploadMes,
        circle: ""
      }, {
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_el_icon, {
        onClick: toTop,
        key: "plain"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ArrowLeftBold)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})